"use client";
import {
    Bars4Icon,
    GlobeAmericasIcon, NewspaperIcon,
    PhoneIcon, RectangleGroupIcon,
    SquaresPlusIcon,
    SunIcon, TagIcon,
    UserGroupIcon
} from "@heroicons/react/24/solid";
import React, {useState} from "react";
import {  useRouter } from "next/navigation";

import Link from 'next/link'

import {
    Collapse,
    IconButton,
    ListItem,
    Menu,
    MenuHandler,
    MenuItem,
    MenuList,
    Typography
} from "@material-tailwind/react";
import {ChevronDownIcon} from "@heroicons/react/24/outline";
import {Squares2X2Icon} from "@heroicons/react/16/solid";

const navListMenuItems = [
    {
        title: "Home",
        description: "Find and manage your assets",
        icon: SquaresPlusIcon,
        destination: "/manage",
    },

    {
        title: "My Applications",
        description: "Search my applications",
        icon: UserGroupIcon,
        destination: "/manage/application",
    },


];

export function ManageMenu() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const renderItems = navListMenuItems.map(
        ({ icon, title, description, destination }, key) => (
            <Link href={destination} key={key}>
                <MenuItem className="flex items-center gap-3 rounded-lg">
                    <div className="flex items-center justify-center rounded-lg !bg-blue-gray-50 p-2 ">
                        {" "}
                        {React.createElement(icon, {
                            strokeWidth: 2,
                            className: "h-6 text-gray-900 w-6",
                        })}
                    </div>
                    <div>
                        <Typography
                            variant="h6"
                            color="black"
                            className="flex items-center text-sm font-bold"
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="paragraph"
                            className="text-xs !font-medium text-blue-gray-500"
                        >
                            {description}
                        </Typography>
                    </div>
                </MenuItem>
            </Link>
        )
    );

    return (
        <Menu
            open={isMenuOpen}
            handler={setIsMenuOpen}

            placement="bottom-start"
            allowHover={false}
        >
            <MenuHandler>
                <Typography as="div" variant="small" className="font-medium">
                    <IconButton variant="text">
                        <Squares2X2Icon className="h-5 w-5 text-gray-400" />
                    </IconButton>
                </Typography>
            </MenuHandler>
            <MenuList className="hidden max-w-screen-xl rounded-xl block">
                <ul className="grid grid-cols-2 gap-y-2 outline-none outline-0">
                    {renderItems}
                </ul>
            </MenuList>
        </Menu>
    );
}